export default __webpack_public_path__ + "static/media/LukePTestimonial.7d3cb1f6.png";